import actions from './actions';

const initState = {
    accounting   : {
        data: []
    },
    loading : false,
    acceptRejectAccounting: false
};

export default function fetchAccountingReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_ACCOUNTING_REQUESTED:
            return {
                ...state,
                accounting : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_ACCOUNTING_SUCCEEDED:
            return {
                ...state,
                accounting    : action.accounting,
                loading     : false
            };
        case actions.FETCH_ACCOUNTING_FAILED:
            return {
                ...state,
                loading : false
            };
        default:
            return state;
    }
}
